import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import i18next from 'i18next';
import { firstValueFrom } from 'rxjs';
import { CoreService } from 'src/app/core/services/core.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UserService } from 'src/app/core/services/user.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { Collective, User } from 'src/app/shared/model/user.model';
import { HandlePermissions } from 'src/app/shared/utils/permissions';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  user!: User;
  token = '';
  nis = '';
  selectedItem: any = 'home';
  landing2 = false;
  collective = Collective;

  constructor(
    private router: Router,
    private storageService: StorageService,
    private userService: UserService,
    private coreService: CoreService,
    private navigationService: NavigationService,
    public dialog: MatDialog,
    public handlePermissions: HandlePermissions
  ) {}

  ngOnInit() {
    this.landing2 = this.storageService.get('landing2');

    if (this.storageService.get('config')) {
      if ((this.nis = this.storageService.get('config').nis)) {
        firstValueFrom(this.userService.getUser()).then((res: User) => {
          this.user = res;

          if (this.user?.groupType === this.collective.EXTERNVO) {
            this.landing2 = true;
          }
        });
      }
    }
  }

  ngAfterViewInit(): void {
    this.navigationService.subject.subscribe((data) => {
      this.selectedItem = data;
      this.landing2 = this.storageService.get('landing2');
    });
  }

  changeMenu(data: string) {
    this.selectedItem = data;
  }
  onClickLogOut() {
    this.storageService.get('token')
      ? (this.token = this.storageService.get('token').token)
      : (this.token = '');
    this.coreService.logout(this.token).subscribe({
      next: () => {
        sessionStorage.removeItem('config');
        this.storageService.removeItem('token');
        this.router.navigateByUrl('/login');
      }
    });
  }

  onClickLogo() {
    this.router.navigateByUrl('/landing');
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  onlyLandingLeasing() {
    if (!this.user) return false;
    if (!this.user.groupType) return false;
    if (
      this.user.groupType === Collective.PSS ||
      this.user.groupType === Collective.EXP
    ) {
      return true;
    }
    return false;
  }

  canGoToLandingLeasing() {
    if (!this.user) return false;
    if (!this.user.groupType) return false;
    if (this.user.groupType === Collective.EXT) {
      return false;
    }
    return true;
  }

  /**
   * Open support text modal
   */
  openSupportModal(): void {
    this.dialog.open(FeedbackModalComponent, {
      width: '600px',
      data: {
        text: i18next.t('supportMsg'),
        close: true,
        theme: 'dark'
      }
    });
  }

  manageData() {
    this.router.navigateByUrl('/manage-data');
  }
}
